import ukMoment from "../../../../utils/ukTime";
import { Link } from "react-router-dom";

import styles from "../../../../styles/Calendar.module.scss";

function Session({session, selectedSessions, toggleSession, user}) {
	const unavailable = session.withheld || session.booked || session.past;
	const capacityText = Number.isInteger(session.remainingCapacity) && Number.isInteger(session.capacity)
		? `${session.remainingCapacity}/${session.capacity} left`
		: null;
	const selected = selectedSessions.some((selectedSession) => {
		return selectedSession.studio?._id === session.studio?._id
			&& selectedSession.start === session.start
			&& selectedSession.end === session.end;
	});

	if(unavailable) {
		// Waitlist is a Paid Extras perk - only link through to it for a paid user, and
		// never for a session that's already happened (nothing to wait for there).
		if(user?.paidExtrasActive && !session.past) {
			return (
				<Link
					to={`/dashboard/book/${session.studio?._id}/confirm?start=${encodeURIComponent(session.start)}&end=${encodeURIComponent(session.end)}`}
					className={`${styles.session} ${styles.unavailable} ${styles.waitlistAvailable}`}
				>
					<p>{ukMoment(session.start).format('h:mm A')}</p>
					{session.waitlisted && <span>Waitlisted</span>}
				</Link>
			)
		}
		return <p className={`${styles.session} ${styles.unavailable}`}>{ukMoment(session.start).format('h:mm A')}{capacityText && <span>{capacityText}</span>}</p>
	} else {
		return (
			<button type="button" onClick={() => toggleSession(session)} className={`${styles.session} ${selected ? styles.selected : ""}`}>
				<p>{ukMoment(session.start).format('h:mm A')}</p>
				{capacityText && !selected && <span>{capacityText}</span>}
				{selected && <span>In cart</span>}
			</button>
		)
	}
}

export default Session;
